import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=3166422a&scoped=true"
import script from "./editForm.vue?vue&type=script&lang=ts"
export * from "./editForm.vue?vue&type=script&lang=ts"
import style0 from "./editForm.vue?vue&type=style&index=0&id=3166422a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3166422a",
  null
  
)

export default component.exports